<div class="view-tables-container">
  <!-- Table View -->
  <div *ngIf="showTableView && selectedTable" class="table-view-wrapper">
    <bhub-table-view
      [table]="selectedTable"
      (backClick)="onBackToList()">
    </bhub-table-view>
  </div>

  <!-- Tables List -->
  <div *ngIf="!showTableView" class="tables-list-view">
    <div class="header">
      <h2>View Tables</h2>
      <p>Browse and view your custom table configurations</p>
    </div>

    <div class="content">
      <!-- Loading spinner -->
      <div *ngIf="loading" class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Loading tables...</p>
      </div>

      <!-- Tables list -->
      <div *ngIf="!loading" class="tables-list">
        <div *ngFor="let table of tables" class="table-item" (click)="onViewTable(table)">
          <div class="table-info">
            <div class="table-header">
              <h3>{{ table.tableName }}</h3>
              <div class="table-badges">
                <span *ngIf="table.isDefault" class="badge default">Default</span>
                <span *ngIf="table.isShared" class="badge shared">Shared</span>
              </div>
            </div>
            <p>{{ table.tableDescription || 'No description available' }}</p>
            <div *ngIf="table.isShared && table.sharedTo?.length > 0" class="shared-users">
              <span class="shared-label">Shared with:</span>
              <span class="shared-emails">{{ table.sharedTo.join(', ') }}</span>
            </div>
            <div class="table-meta">
              <span class="meta-item">
                <mat-icon>schedule</mat-icon>
                Modified: {{ table.modifiedDate | date:'short' }}
              </span>
              <span class="meta-item">
                <mat-icon>person</mat-icon>
                {{ table.modifiedBy }}
              </span>
              <span class="meta-item">
                <mat-icon>view_column</mat-icon>
                {{ table.columnList.length }} columns
              </span>
            </div>
          </div>
          <div class="table-actions">
            <button mat-raised-button color="primary">
              <mat-icon>visibility</mat-icon>
              View
            </button>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="!loading && tables.length === 0" class="no-tables">
        <mat-icon class="empty-icon">table_chart</mat-icon>
        <p>No tables found. Create your first table to get started.</p>
      </div>
    </div>
  </div>
</div>
